var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-sheet",
    {
      staticClass: "d-flex pa-2",
      staticStyle: {
        position: "fixed",
        right: "16px",
        bottom: "16px",
        "z-index": "200",
        "align-items": "center",
        "justify-content": "flex-end",
      },
      attrs: { color: "transparent" },
    },
    [
      _vm.scrollOffsetArr && _vm.scrollOffsetArr.length > 0
        ? _c(
            "v-flex",
            {
              staticClass: "mr-3",
              staticStyle: { "flex-direction": "row" },
              attrs: { shrink: "" },
            },
            [
              _c(
                "v-tooltip",
                {
                  attrs: { top: "", "open-on-click": false },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-fab-transition",
                              [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.enableScrollPrev,
                                            expression: "enableScrollPrev",
                                          },
                                        ],
                                        attrs: { small: "", fab: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.goTo(
                                              _vm.scrollPrevTarget
                                            )
                                          },
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("v-icon", [
                                      _vm._v(_vm._s(_vm.$MDI.ChevronUp)),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    4163504788
                  ),
                },
                [_vm._v(" "), _c("span", [_vm._v("Scroll to prev. cluster")])]
              ),
              _vm._v(" "),
              _c(
                "v-tooltip",
                {
                  attrs: { top: "", "open-on-click": false },
                  scopedSlots: _vm._u(
                    [
                      {
                        key: "activator",
                        fn: function ({ on, attrs }) {
                          return [
                            _c(
                              "v-fab-transition",
                              [
                                _c(
                                  "v-btn",
                                  _vm._g(
                                    _vm._b(
                                      {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: _vm.enableScrollNext,
                                            expression: "enableScrollNext",
                                          },
                                        ],
                                        attrs: { small: "", fab: "" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.goTo(
                                              _vm.scrollNextTarget
                                            )
                                          },
                                        },
                                      },
                                      "v-btn",
                                      attrs,
                                      false
                                    ),
                                    on
                                  ),
                                  [
                                    _c("v-icon", [
                                      _vm._v(_vm._s(_vm.$MDI.ChevronDown)),
                                    ]),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ]
                        },
                      },
                    ],
                    null,
                    false,
                    2555958869
                  ),
                },
                [_vm._v(" "), _c("span", [_vm._v("Scroll to next cluster")])]
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-tooltip",
        {
          attrs: { top: "", color: "primary", "open-on-click": false },
          scopedSlots: _vm._u([
            {
              key: "activator",
              fn: function ({ on, attrs }) {
                return [
                  _c(
                    "v-fab-transition",
                    [
                      _c(
                        "v-btn",
                        _vm._g(
                          _vm._b(
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.enableScrollTop,
                                  expression: "enableScrollTop",
                                },
                              ],
                              attrs: { color: "primary", fab: "" },
                              on: {
                                click: function ($event) {
                                  return _vm.goTo(0)
                                },
                              },
                            },
                            "v-btn",
                            attrs,
                            false
                          ),
                          on
                        ),
                        [
                          _c("v-icon", [
                            _vm._v(_vm._s(_vm.$MDI.DoubleChevronUp)),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]
              },
            },
          ]),
        },
        [_vm._v(" "), _c("span", [_vm._v("Scroll to top")])]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }